import ValidationError from "./ValidationError"

class TwitterMediaAssetsValidationError extends ValidationError {
    constructor(msg: string) {
        super(msg);

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, TwitterMediaAssetsValidationError.prototype);
    }

    getErrorMessage() {
        return this.message;
    }
}

export default TwitterMediaAssetsValidationError;
